export default "<div style=\"min-height: 100%; position: relative;\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n"